import React, { useEffect, useState } from 'react'
import Popup from '../../Components/Popup'
import { CheckValidation } from '../../Components/Validations';
import { ApiGetCall, ApiGetCallAuthKey, ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { LogInUserID } from '../../JS/Common';

export default function RepairTypeModal(props) {
    const [repairTypeData, setRepairTypeData] = useState({
        repairtypename: "",
        point: "",
        isunderwarranty: 2,
        UseSecondaryPricing: 2,
    });
    useEffect(() => {
        if (props.flag == 2) {
            const GetAllRepairTypes = async () => {
                props.setLoading(true);
                await ApiGetCall(`/devices/types/fetch?uuid=${props.repairtypeid}`).then((result) => {
                    if (result == undefined || result == "") {
                        alert("Something went wrong");
                    } else {
                        const responseRs = JSON.parse(result);
                        props.setLoading(false);
                        setRepairTypeData({
                            repairtypename: responseRs.type,
                            point: responseRs.point,
                            isunderwarranty: responseRs.under_warranty || 2,
                            UseSecondaryPricing: responseRs.discount_for_repair_type || 2
                        });
                    }
                });
            }
            GetAllRepairTypes();
        }
    }, [props.repairtypeid]);
    const modalbody = (
        <div className='row parent' id='RepairTypeDiv'>
            <div className='col-12'>
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style font-13'>Repair Type Name<label className='redText'>*</label></div>
                <input className="form-control" type="text" required name={`repairtype`}
                    value={repairTypeData.repairtypename}
                    onChange={(e) => setRepairTypeData({ ...repairTypeData, repairtypename: e.target.value })}
                    placeholder={`Enter Repair Type Name`}
                />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-md-6 pt-3'>
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style font-13'>Point<label className='redText'>*</label></div>
                <input className="form-control" type="number" required name={`point`}
                    value={repairTypeData.point}
                    onChange={(e) => setRepairTypeData({ ...repairTypeData, point: e.target.value })}
                    placeholder={`Enter Point`}
                />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-md-6 pt-3'>
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style font-13'>Is Under Warranty ?<label className='redText'>*</label></div>
                <select className="form-select" name={`isunderwarranty`}
                    value={repairTypeData.isunderwarranty}
                    onChange={(e) => setRepairTypeData({ ...repairTypeData, isunderwarranty: e.target.value })}>
                    <option value="1">Yes</option>
                    <option value="2">No</option>
                </select>
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-12 pt-3'>
                <div className='d-flex gap-2'>
                    <input type="checkbox" className='form-check-input' id='repair-secondary-pricing'
                        onChange={(e) => setRepairTypeData(prev => ({ ...prev, UseSecondaryPricing: e.target.checked ? 1 : 2 }))}
                        checked={repairTypeData.UseSecondaryPricing == 1} />
                    <label htmlFor='repair-secondary-pricing'>Repair Type Uses Secondary Pricing?</label>
                </div>
            </div>
        </div>
    );
    const handleSaveRepairType = async (e) => {
        var isFormValid = CheckValidation({ formID: 'RepairTypeDiv' });
        if (!isFormValid) return;
        const raw = JSON.stringify({
            deviceType: repairTypeData.repairtypename,
            point: repairTypeData.point,
            underWarranty: repairTypeData.isunderwarranty,
            uuid: props.flag == 1 ? 0 : props.repairtypeid,
            discountForRepairType: repairTypeData.UseSecondaryPricing,
            loginUserId: LogInUserID
        });
        props.setLoading(true);
        await ApiPostCall("/devices/types/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                props.setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    var msg = props.flag == 1 ? "New Repair Type Added Successfully." : 'Repair Type Updated Successfully.';
                    props.setAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    props.closepopup();
                    setTimeout(() => {
                        props.setAlerts(<AlertsComp show={false} />);
                        props.GetAllRepairTypes();
                    }, 1500);
                }
                else {
                    props.setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        props.setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    return (
        <div>
            <Popup isshow={props.isShow} size={"md"} title={`${props.flag == 1 ? 'Add Repair Type' : 'Edit Repair Type'}`}
                closePopup={(e) => props.closepopup()} modalBody={modalbody} visibleSaveBtn={true}
                handleSave={handleSaveRepairType} btnText={props.flag == 1 ? "Save" : "Update"} />
        </div>
    )
}
